class ArticleCategoriesCarousel {
  constructor() {
    // Support both article-categories and blog-category-filter sections
    this.nav = document.querySelector('.article-categories__nav') ||
               document.querySelector('.blog-category-filter__nav');

    this.wrapper = document.querySelector('.article-categories__carousel-wrapper') ||
                   document.querySelector('.blog-category-filter__carousel-wrapper');

    if (!this.nav || !this.wrapper) return;

    // Query pills only within the nav element (not globally)
    this.pills = this.nav.querySelectorAll('.category-pill');
    this.leftArrow = this.wrapper.querySelector('.carousel-arrow--left');
    this.rightArrow = this.wrapper.querySelector('.carousel-arrow--right');

    if (this.pills.length === 0) return;

    this.init();
  }

  init() {
    // Event listeners
    this.leftArrow?.addEventListener('click', () => this.scrollLeft());
    this.rightArrow?.addEventListener('click', () => this.scrollRight());

    this.nav.addEventListener('scroll', () => this.updateArrows());

    window.addEventListener('resize', this.debounce(() => {
      this.scrollToFirst();
      this.updateArrows();
    }, 250));

    // Initial setup - wait for layout to be complete
    this.setupCarousel();

    // Also update on window load (after fonts, images, etc.)
    if (document.readyState === 'complete') {
      this.setupCarousel();
    } else {
      window.addEventListener('load', () => this.setupCarousel());
    }
  }

  setupCarousel() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.scrollToFirst();
        this.updateArrows();
      });
    });
  }

  scrollToFirst() {
    // Always scroll to the first category on load or resize
    if (this.nav) {
      this.nav.scrollLeft = 0;
    }
  }

  updateArrows() {
    if (!this.nav || !this.leftArrow || !this.rightArrow) return;

    const scrollLeft = this.nav.scrollLeft;
    const scrollWidth = this.nav.scrollWidth;
    const clientWidth = this.nav.clientWidth;
    const maxScroll = scrollWidth - clientWidth;

    // Show/hide arrows based on scroll position and overflow
    const hasOverflow = scrollWidth > clientWidth;

    if (!hasOverflow) {
      // No overflow - hide both arrows
      this.leftArrow.classList.remove('visible');
      this.rightArrow.classList.remove('visible');
    } else {
      // Has overflow - show arrows based on position
      // Left arrow: show if not at the start
      if (scrollLeft > 10) {
        this.leftArrow.classList.add('visible');
      } else {
        this.leftArrow.classList.remove('visible');
      }

      // Right arrow: show if not at the end
      if (scrollLeft < maxScroll - 10) {
        this.rightArrow.classList.add('visible');
      } else {
        this.rightArrow.classList.remove('visible');
      }
    }
  }

  scrollLeft() {
    if (!this.nav) return;

    const scrollAmount = this.getScrollAmount();
    this.nav.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  }

  scrollRight() {
    if (!this.nav) return;

    const scrollAmount = this.getScrollAmount();
    this.nav.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  getScrollAmount() {
    // Calculate how much to scroll based on visible width
    const containerWidth = this.nav.clientWidth;

    // Get the gap between items
    const navStyles = window.getComputedStyle(this.nav);
    const gap = parseInt(navStyles.gap) || 48; // Default to 48px (gap-12)

    // Calculate average item width
    let totalWidth = 0;
    let visibleItems = 0;

    this.pills.forEach((pill) => {
      const pillWidth = pill.offsetWidth;
      if (totalWidth + pillWidth <= containerWidth) {
        totalWidth += pillWidth + gap;
        visibleItems++;
      }
    });

    // Scroll by approximately 2-3 items or half the container width
    const avgItemWidth = visibleItems > 0 ? totalWidth / visibleItems : containerWidth / 3;
    const scrollAmount = Math.max(avgItemWidth * 2, containerWidth * 0.5);

    return scrollAmount;
  }

  // Debounce helper function
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ArticleCategoriesCarousel();
  });
} else {
  new ArticleCategoriesCarousel();
}
